import { apiDelete, apiGet, apiPut } from './api';
import type { CourseSessionRow } from './sessionsApi';

export type SessionFilters = {
  page?: number;
  limit?: number;
  /** Match sessions where user is student or teacher */
  userId?: string;
  studentId?: string;
  teacherId?: string;
  status?: string;
  attendanceStatus?: string;
  sessionType?: string;
  startDate?: string;
  endDate?: string;
};

export async function listAllCourseSessions(filters: SessionFilters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      params.set(key, String(value));
    }
  });
  const qs = params.toString();
  return apiGet<{
    success: boolean;
    data: {
      sessions: CourseSessionRow[];
      pagination: { page: number; limit: number; total: number; pages: number };
    };
  }>(`/api/v1/admin/course-sessions${qs ? `?${qs}` : ''}`);
}

export async function updateCourseSession(
  sessionId: string,
  body: Partial<CourseSessionRow> & {
    teacherNotes?: string;
    studentNotes?: string;
    location?: string;
  }
) {
  return apiPut<{ success: boolean; data?: CourseSessionRow; message?: string }>(
    `/api/v1/course-sessions/${sessionId}`,
    body
  );
}

export async function deleteCourseSession(sessionId: string) {
  return apiDelete<{ success: boolean; message?: string }>(`/api/v1/course-sessions/${sessionId}`);
}
